import useIssueReporter from '../../hooks/useIssueReporter';

/**
 * IssueReporterHandler is a component that activates the issue reporter hook.
 * It should be placed inside the VideoContext.Provider to have access to the room.
 * This component doesn't render anything visible - it just monitors for issues
 * and reports them to the backend.
 */
export default function IssueReporterHandler() {
  // Enable issue reporting - this hook handles all the monitoring and reporting
  useIssueReporter(true);
  
  // This component doesn't render anything visible
  return null;
}
